'use strict';

var formValidation = require('../components/formValidation');
var createErrorNotification = require('base/components/errorNotification');

var location = window.location;

module.exports = {
    handleRegistrationErrors: function () {
        $('form.registration').on('login:register:error', function(event, params){
            var { data, isMobile } = params;
            if (data.errorCode && data.errorCode.toUpperCase() === "EMAIL_EXISTS") {
                var bottomSheetId = $('.bottomsheet-id').data('bottom-sheet-id');
                var errorModalId =  bottomSheetId;

                if (!isMobile) {
                    errorModalId = 'modal' + errorModalId
                }

                var $errorModal = $('#' + errorModalId);

                if ($errorModal.length) {
                    $errorModal.find('p.registrationmodal_msg').html(data.errorMessage);
                    if (isMobile) {
                        $(document).trigger('openBottomSheetRequest', { targetId: `#${errorModalId}` });
                    }
                    else {
                        $errorModal.modal('show');
                    }
                }

            }
        });
    },

    login: function () {
        $('form.login').submit(function (e) {
            var form = $(this);
            var $migratedCustomerModal = $('.migrated-customer-modal');
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.isMigratedCustomer) {
                            $migratedCustomerModal.modal('show');
                            const $messageContainer = form.find('.migrated-message-container');
                            const warningInformation = $(`
                                <div class="alert alert-warning" role="alert">
                                    <img src=${form.data('migrated-msg-icon')} alt=${form.data('migrated-msg-icon-alt')}/>
                                    <div class="migrated-msg-text">
                                        ${data.migrationMessage}
                                    </div>
                                </div>
                            `);
                            $messageContainer.empty().append(warningInformation);
                        } else {
                            formValidation(form, data);
                            $('form.login').trigger('login:error', data);
                        }
                    } else {
                        $('form.login').trigger('login:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    },

    register: function () {
        $('form.registration').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            var submitterButton = e.originalEvent.submitter;
            var isMobile = $(submitterButton).data('is-mobile');
            $('form.registration').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $('form.registration').trigger('login:register:error', { data: data, isMobile: isMobile});
                        formValidation(form, data);
                    } else {
                        $('form.registration').trigger('login:register:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }

                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    resetPassword: function () {
        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append('<p class="success-message">' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $('#submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            const passwordResetTitle = $('.passwordreset_page-title');
                            passwordResetTitle.text(data.receivedMsgHeading);
                            passwordResetTitle.addClass('success-title')
                            $('.send-email-btn').empty()
                                .html('<a href="'
                                    + data.returnUrl
                                    + '" class="btn btn-primary btn-block btn-send-mobile">'
                                    + data.buttonText + '</a>');
                        }

                        $('#requestPasswordResetModal').on('hidden.bs.modal', function () {
                            location.reload();
                        });
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },

    closeMigratedCustomerModalFunction: function () {
        $('.migrated-customer-modal').on('hidden.bs.modal', function () {
            $(this).removeClass('show');
            $('.modal-backdrop').remove();
        });
    
        var closeModal = function () {
            $('.migrated-customer-modal').modal('hide').on('hidden.bs.modal', function () {
                $(this).removeClass('show');
                $('.modal-backdrop').remove();
            });
        };
    
        $('.migrated-customer-modal .confirm-modal').on('click', closeModal);
    }
};
